import React, { useState, Fragment, useEffect } from "react";
import { AxiosInstance, AxiosResponse } from "axios";
import { connect } from "react-redux";
import { iRootState } from "../../../../rematch/store";
import AsyncSelect from 'react-select/async';
import { SelectOption } from "../FilterOperatorSelect";
import { useTranslation } from "react-i18next";
import { getSelectedObjectValues, searchItems, sortAndFilterSelectOptions } from "./LookupHelper";
import IMFilesPropertyDefinition from "src/backend/interfaces/mfiles/IMFilesPropertyDefinition";
import { IMfilesObject } from "src/backend/interfaces/mfiles/IMFilesObject";

import { debounce, uniqueId } from "lodash";


interface ILookupListProps {
  filterKey          : string;
  selectedValues    : string[];
  isMultiSelect     : boolean;
  propertyDefinition : IMFilesPropertyDefinition;
  onChange: (newSelectedIds: string[]) => void;

  httpClient: AxiosInstance;
}

const LookupList = (props: ILookupListProps): JSX.Element => {
  
  const { t } = useTranslation();

  const [currSelectedValue, setCurrSelectedValue] = useState<SelectOption[]>();

  const loadOptions = (inputValue: string) => getObjectLookup(inputValue, props.propertyDefinition, props.httpClient)

  const debouncedLoadOptions = debounce(loadOptions, 0, { leading: true });

  useEffect(() => {
  
    getObjectLookup("", props.propertyDefinition, props.httpClient);

  }, [props.selectedValues, props.propertyDefinition]);


  useEffect(() => {
    setInitialValues();
  }, [props.filterKey])

  const setInitialValues = async () => {
    setCurrSelectedValue(null);

    let lookupSelection = await getSelectedObjectValues(props.httpClient, props.propertyDefinition.ValueList, props.selectedValues)
    setCurrSelectedValue(lookupSelection);
  }

  /**
   * Get Lookup for field
   */
  const getObjectLookup = async(searchTerm: string, propDef: IMFilesPropertyDefinition, httpClient: AxiosInstance): Promise<SelectOption[]> => {

    const results            = await searchItems(searchTerm, propDef.ValueList, propDef, httpClient);
    const validLookupOptions = results.map( (i: IMfilesObject): SelectOption => ({value: i.ObjVer.ID.toString(), label: i.Title}) );

    return sortAndFilterSelectOptions(validLookupOptions, searchTerm);
  }

  /**
   * Update login on dropdown value change
   */
  const onSelectChange = (item: SelectOption | SelectOption[]) => {

    if (item === null) { // handle clear
      setCurrSelectedValue(null);
      props.onChange([]);
      return;
    }

    if ( props.isMultiSelect ) {

      const newSelectedItems = (item as SelectOption[]).map((item) => parseInt(item.value));

      setCurrSelectedValue( item as SelectOption[] );
      props.onChange(newSelectedItems.map(i => i.toString()));

    } else {

      setCurrSelectedValue( [item as SelectOption] );
      props.onChange( [(item as SelectOption).value] );
    }
  }

  return (
    <Fragment>
      <AsyncSelect
        defaultOptions
        value={currSelectedValue}
        loadOptions={inputValue => debouncedLoadOptions(inputValue)}
        isMulti={props.isMultiSelect}
        isClearable={true}
        closeMenuOnSelect={false}
        placeholder={`${t("command.select")}...`}
        styles={{ 
          menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
          control: (base) => ({...base, background: 'white', border: '1px solid #78899a', borderRadius: 'none'}),
          multiValue: (base) => ({...base, fontSize: "16px"}), //multiValue child has 85% font
          option: provided => ({...provided, color: 'black'}),
        }}
        onChange={(value: SelectOption | SelectOption[]) => onSelectChange(value)}
      ></AsyncSelect>
    </Fragment>
  );
};

export default connect((rootState: iRootState) => ({
  httpClient: rootState.common.httpClient,
}))(LookupList);
